<template>
    <div class="page-register">
        <div class="img-logo">
            <img src="@/assets/img/01-register/logo-big@3x.png">
        </div>
        <div class="text-title">{{lbl.register.registeration}}</div>
        <!-- block form -->
        <div class="box-content">
            <div class="text-label-input">{{lbl.register.birthday}}</div>
            <div class="row no-gutters">
                <div class="col-6 pr-1">
                    <b-dropdown class="ddl-default"
                                variant="ddl-default"
                                menu-class="ddl-menu"
                                :class="{'active' : formModel.day != ''}"
                                :text="ddl.textDay">
                        <b-dropdown-item v-for="(v,k) in ddl.dayList" :key="k" @click="selectDropdownDay(v)">
                            {{v}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="col-6 pl-1">
                    <b-dropdown class="ddl-default"
                                variant="ddl-default"
                                menu-class="ddl-menu"
                                :class="{'active' : formModel.month != ''}"
                                :text="ddl.textMonth">
                        <b-dropdown-item v-for="(v,k) in ddl.monthList" :key="k" @click="selectDropdownMonth(v)">
                            {{v}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
            <div class="text-error-label">{{errorInputDate}}</div>
            <div class="mt-1">
                <input-contact-number
                        v-if="refreshView"
                        inputId="register-contact-number"
                        v-model="formModel.contactNumber"
                        :inputLbl="lbl.register.contactnumber"
                        :inputMinLength="12"
                        :inputMaxLength="12"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"
                        :showLabelOnInputOnly="true"
                        delimeter="-"
                ></input-contact-number>
            </div>
            <!-- end block form -->

            <!-- block btn -->
            <div class="register-divider">
                <div class="line"></div>
                <div class="wrap-text">
                    <div class="text">{{lbl.register.or}}</div>
                </div>
            </div>

            <div class="msg-register">
                {{lbl.register.click_to_scan}}
            </div>
            <div>
                <button class="btn-black" v-if="checkTerm" @click="openScanQrCode()">
                    {{lbl.register.scan_qr_code}}
                </button>
                <button class="btn-gray" v-else>
                    {{lbl.register.scan_qr_code}}
                </button>
            </div>
            <div class="d-flex mt-5 mb-3">
                <div class="checkbox-icon flex-shrink-0" @click="clickCheckboxTerm()">
                    <img v-if="!checkTerm" src="@/assets/img/01-register/checkbox-inactive@3x.png">
                    <img v-else src="@/assets/img/01-register/checkbox-active@3x.png">
                </div>
                <div class="checkbox-text">
                    <term-condition-modal v-if="refreshView" :busModal="busTerm"></term-condition-modal>
                </div>
            </div>
            <div class="text-error-label text-center">{{errorCheckTerm}}</div>
            <div>
                <button class="btn-black" @click="clickContinue()">{{lbl.default.continue}}</button>
            </div>
            <!-- end block btn -->

            <!-- block switch lang -->
            <div class="mt-4">
                <div class="d-flex justify-content-center">
                    <div>
                        <button class="btn-lang"
                                :class="{'active' : localeCode == 1033}"
                                @click="switchLang(1033)">
                            ENG
                        </button>
                    </div>
                    <div class="btn-divider">&nbsp;</div>
                    <div>
                        <button class="btn-lang"
                                :class="{'active' : localeCode == 1054}"
                                @click="switchLang(1054)">
                            ไทย
                        </button>
                    </div>
                </div>
            </div>
            <!-- end block switch lang -->

            <div class="text-center pt-5">
                <img class="logo-bzb" src="@/assets/img/01-register/buzzebees-logo@3x.png">
            </div>
        </div>
    </div>
</template>
<script>
//lib
import Vue from "vue";
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//component
import InputContactNumber from "@/components/common/input/ContactNumber.vue";
import TermConditionModal from '@/components/modal/TermConditionModal.vue';
//service
// import BzbsOtp from "@/service/BzbsOtp.js";
import { TrackingService } from "@/helper/TrackingHelper";
/**
 * @event onPageChange
 */
export default {
    name: "RegisterPhone",
    components: {
        InputContactNumber,
        TermConditionModal,
    },
    data: function() {
        return {
            ddl: {
                dayList: [],
                monthList: [],
                textDay: 'Day',
                textMonth: 'Month',
            },
            formModel: {
                day: '',
                month: '',
                contactNumber: '',
            },
            isFirstSave: true,
            errorInfo: [],
            checkTerm: false,
            errorInputDate: '',
            errorCheckTerm: '',

            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            refreshView: true,

            busTerm: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        this.initDropdownDate();
        console.log("register");
        this.errorInfo.push({
            isValid: true,
            msg: '',
        });
        this.ddl.textDay = this.lbl.default.day;
        this.ddl.textMonth = this.lbl.default.month;
    },
    methods: {
        //#region dropdown
        initDropdownDate: function() {
            var i;
            for (i=1 ; i<=31 ; i++) {
                var d = i < 10 ? '0'+i : ''+i;
                this.ddl.dayList.push(d);
            }
            for (i=1 ; i<=12 ; i++) {
                var m = i < 10 ? '0'+i : ''+i;
                this.ddl.monthList.push(m);
            }
            // this.ddl.monthList = this.lbl.date.month_full;
        },
        selectDropdownDay: function(day) {
            this.formModel.day = day;
            this.ddl.textDay = day;

            if (!this.isFirstSave) {
                this.isDateInputValid();
            }
        },
        selectDropdownMonth: function(month) {
            this.formModel.month = month;
            this.ddl.textMonth = month;

            if (!this.isFirstSave) {
                this.isDateInputValid();
            }
        },
        // remove date 20/06/2020 Piyachat
        // setupDropdownAfterLocaleChange: function() {
        //     var monthIndex = this.formModel.month ;
        //     this.ddl.monthList = this.lbl.date.month_full;
        //     if (monthIndex == '') {
        //         this.ddl.textMonth = 'Month';
        //     } else {
        //         this.ddl.textMonth = this.ddl.monthList[monthIndex];
        //     }
        // },
        //#endregion dropdown

        clickCheckboxTerm: function() {
            this.checkTerm = !this.checkTerm;
            if (this.checkTerm) {
                this.errorCheckTerm = '';
            }
        },

        switchLang: function(locale) {
            console.log(locale);
            Account.apiUpdateProfileLocale(locale)
                .then(profile => {
                    if (profile)
                        this.profile = profile;
                    // this.setupDropdownAfterLocaleChange();
                })
                .catch(() => {});
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
            this.localeCode = Locale.getLocaleCode();
            this.forceRender();
            this.switchLangDropdown();
            if (!this.isFirstSave) {
                this.validateForm();
            }


        },
        switchLangDropdown: function() {
            if (this.formModel.day == '') {
                this.ddl.textDay = this.lbl.default.day;
            }
            if (this.formModel.month == '') {
                this.ddl.textMonth = this.lbl.default.month;
            }
        },
        goFlowOtp: function() {
            this.$emit('onRequestedOtp', this.formModel);
        },

        changePage: function(changeTo) {
            this.$emit('onPageChange', { page: changeTo });
        },
        forceRender: function() {
            this.refreshView = false;
            this.$nextTick(() => {
                this.refreshView = true;
            });
        },
        openScanQrCode: function() {
            window.location = "https://line.me/R/nv/QRCodeReader";
        },

        //#region form submit
        clickContinue: function() {
            if (this.validateForm()) {
                // this.requestOtp();
                this.goFlowOtp();
                this.tracking.event('register', 'click_register');
            }
        },
        validateForm: function() {
            var pass = true;
            this.isFirstSave = false;
            if (!this.isDateInputValid()) {
                pass = false;
            }
            for (var i of this.errorInfo) {
                if (!i.isValid) {
                    pass = false;
                }
            }
            this.errorCheckTerm = '';
            if (!this.checkTerm) {
                this.errorCheckTerm = this.lbl.register.term.required;
                pass = false;
            }
            return pass;
        },
        isDateInputValid: function() {
            this.errorInputDate = '';
            if (Util.isEmptyStr(this.formModel.day)) {
                this.errorInputDate = this.lbl.register.birthdate.pleasefill;
                return false;
            }
            if (Util.isEmptyStr(this.formModel.month)) {
                this.errorInputDate = this.lbl.register.birthdate.pleasefill;
                return false;
            }
            return true;
        },
        // remove date 20/06/2020 Piyachat
        // requestOtp: function() {
        //     BzbsOtp.requestOtp(this.formModel.contactNumber, null).then((res) => {
        //         console.log(res.data);
        //         this.formModel.refcode;
        //         this.goFlowOtp();
        //     }).catch((err) => {
        //         if (err.response) {
        //             console.log(err.response.data);
        //         } else {
        //             console.log(err);
        //         }
        //     });
        // },
        //#endregion form submit
    },
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../assets/img/01-register/dropdown@3x.png');
    @import "@/style/base/common.scss";
    @import "@/style/base/inputCustom/Dropdown.scss";
</style>
<style lang="scss" scoped>
    @import "@/style/page/Register.scss";
</style>
